import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import ModalSheet from '../../../components/common/ModalSheet';
import {Button} from '@chekinapp/ui';

export const ProtectionModalText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  color: ${props => props.theme.colors.branding.fontPrimary};
`;

export const Content = styled.div`
  @media (max-width: ${DEVICE.mobileXL}) {
    text-align: left;
  }
`;

export const StyledModalSheet = styled(ModalSheet)`
  &-content {
    max-width: 750px;
    padding-left: 24px;
    padding-right: 24px;
  }

  &-overlay {
    padding-bottom: 0;
  }
`;

export const WrapperText = styled.div`
  h3 {
    margin: 0;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
    color: ${props => props.theme.colors.branding.fontPrimary};
  }
  ul {
    margin: 5px 0 0;
    font-weight: 400;
    text-align: left;
    padding-left: 20px;
  }
`;

export const ProtectionTermButton = styled(Button)`
  margin: 48px auto 0;
`;

export const StyledDepositModal = styled(ModalSheet)`
  &-content {
    max-width: 375px;
    padding-bottom: 10px;
  }

  &-overlay {
    padding-bottom: 0;
  }
`;
